import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

type BrandLogoSize = 'xs' | 'sm' | 'md' | 'lg'

interface BrandLogoProps extends HTMLAttributes<HTMLDivElement> {
  showWordmark?: boolean
  size?: BrandLogoSize
  subtitle?: string
}

export function BrandLogo({
  showWordmark = true,
  size = 'md',
  subtitle,
  className,
  ...props
}: BrandLogoProps) {
  return (
    <div className={cn('aw-brand-logo', `aw-brand-logo-${size}`, className)} {...props}>
      <span className="aw-brand-mark" aria-hidden>
        A
      </span>
      {showWordmark && (
        <span className="aw-brand-copy">
          <span className="aw-brand-wordmark">AgentWiki</span>
          {subtitle && <span className="aw-brand-subtitle">{subtitle}</span>}
        </span>
      )}
    </div>
  )
}
